import { SignType } from '@api';

const getSignTypeFlags = (signType: SignType) => ({
  isSimpleSign: signType === 'simple',
  isSIWE: signType === 'SIWE',
  isSimpleWithNonce: signType === 'simple-with-nonce',
});

export default getSignTypeFlags;
